import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setModal } from "../../../../Features/orderManagementSlice";
import CustomButton from "../../../../Components/Buttons/CustomButton";
import { useSelector } from "react-redux";
import Modal from "../../Modals/Modal";
import RejectedReasonModal from "./RejectedReasonModal";
import { getCachedMediaUrl } from "../../../../lib/utils/utils";
import { updateReturnOrderStatus } from "../../../../lib/utils/apiCalls";
import { showToast } from "../../../../Components/Toaster/Toaster";
import { fetchReturnOrderDetails } from "../../../../Features/orderDetailsSlice";
import ImagePreviewModal from "./ImagePreviewModal";

const ReturnRequestDetails = () => {
  const [isLoading, setisLoading] = useState(false);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const { orderDetails } = useSelector(
    (state) => state.orderDetails.returnOrderDetails
  );

  const dispatch = useDispatch();

  const handleRejectReturn = () => {
    dispatch(setModal("rejectReturn"));
  };

  const handleAcceptReturn = async () => {
    setisLoading(true);

    try {
      const payload = {
        returnStatus: "ACCEPTED",
      };

      const response = await updateReturnOrderStatus(
        orderDetails.orderId,
        payload
      );
      if (response?.status === 200) {
        showToast(
          response.data?.data?.message || "Return order rejected successfully ",
          "success"
        );
        dispatch(fetchReturnOrderDetails(orderDetails.orderId));
      } else {
        showToast("Error in Updating Reject Return.", "error");
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        "Something went wrong. Please try again.";
      showToast(errorMessage, "error");
    } finally {
      setisLoading(false);
    }
  };

  const handleViewReturnReason = () => {
    setShowRejectedModal(true);
  };

  const closeRejectedModal = () => {
    setShowRejectedModal(false);
  };

  const renderStatusActions = () => {
    switch (orderDetails?.returnStatus) {
      case "PENDING":
        return (
          <div className="flex items-center gap-2">
            <CustomButton
              title="Reject"
              variant="red-primary"
              disabled={isLoading}
              onClick={handleRejectReturn}
            />

            <CustomButton
              title="Accept Return"
              disabled={isLoading}
              loading={isLoading}
              onClick={handleAcceptReturn}
            />
          </div>
        );

      case "REJECTED":
        return (
          <div className="flex items-center gap-3">
            <button
              onClick={handleViewReturnReason}
              className="outline-none border-none text-[#1055EB] text-sm font-semibold"
            >
              View reason
            </button>
            <span className="text-[#EF4444] text-sm font-semibold">
              Rejected
            </span>
          </div>
        );

      case "ACCEPTED":
        return (
          <div className="flex items-center gap-3">
            <span className="text-[#00C853] text-sm font-semibold">
              Return Accepted
            </span>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="mx-5 border border-[#EAEAEA] rounded-lg px-4 py-3 mt-5 bg-[#FFFFFF]">
      <div className="flex items-center h-12">
        <h3 className="flex-1 text-[#666] text-base font-semibold">
          Return Request
        </h3>
        {renderStatusActions()}
      </div>
      <h6 className="text-primaryColor text-sm font-semibold">
        Reason for Return
      </h6>
      <p className="text-[#666] text-sm font-bold mt-1">
        {orderDetails?.["Reason.reasonText"]}
      </p>

      {orderDetails?.returnImages?.length > 0 && (
        <div className="mt-5">
          <div className="grid grid-cols-[repeat(auto-fill,180px)] gap-2 justify-start">
            {orderDetails?.returnImages?.map((item, i) => (
              <div
                className="rounded-xl h-[180px] shadow-custom-gray hover:shadow-custom-black-hover transition-shadow duration-700 cursor-pointer overflow-hidden"
                key={i}
                onClick={() => setSelectedImage(getCachedMediaUrl(item))}
              >
                <img
                  src={getCachedMediaUrl(item)}
                  alt=""
                  className="w-full h-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {showRejectedModal && (
        <RejectedReasonModal
          rejectReason={orderDetails?.reasonReject}
          closeRejectedModal={closeRejectedModal}
        />
      )}

      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}

      <Modal />
    </div>
  );
};

export default ReturnRequestDetails;
